import { CommonTableUI } from "../../TableTemplate/common";
import { ITableUI } from "../../TableTemplate/tableTemplate";
import { BrokerOrderesTableAdditional } from "./Additional";

const BrokerOrdersTableUI: React.FC<ITableUI<any>> = ({
  reports,
  onAction,
}: ITableUI<any>) => {
  return <CommonTableUI reports={reports} onAction={onAction} AdditionalBody={BrokerOrderesTableAdditional} />;
};
export default BrokerOrdersTableUI;
